module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "height": "83vh"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "id": "dashboardContainer"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f8b496cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8b496cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/embedded-dashboard/embedded-dashboard.vue.html
// module id = 1137
// module chunks = 0